(() => {
  const initialize = (carousel) => {
    if (carousel.dataset.phReady === 'true') return;

    const viewport = carousel.querySelector('[data-ph-carousel-viewport]');
    const track = carousel.querySelector('[data-ph-carousel-track]');
    const slides = [...carousel.querySelectorAll('[data-ph-carousel-slide]')];
    const dots = [...carousel.querySelectorAll('[data-ph-carousel-dot]')];
    const previous = carousel.querySelector('[data-ph-carousel-previous]');
    const next = carousel.querySelector('[data-ph-carousel-next]');

    if (!viewport || !track || slides.length < 2) return;

    carousel.dataset.phReady = 'true';
    let index = 0;
    let startX = 0;
    let deltaX = 0;
    let dragging = false;
    let autoplayTimer;
    const autoplay = carousel.dataset.phCarouselAutoplay === 'true';
    const autoplayDelay = Math.max(2000, Number(carousel.dataset.phCarouselDelay) || 5000);

    const stopAutoplay = () => window.clearTimeout(autoplayTimer);

    const scheduleAutoplay = () => {
      stopAutoplay();
      if (!autoplay || document.hidden) return;
      autoplayTimer = window.setTimeout(() => {
        show(index + 1);
        scheduleAutoplay();
      }, autoplayDelay);
    };

    const show = (nextIndex, animate = true) => {
      index = (nextIndex + slides.length) % slides.length;
      track.classList.toggle('is-dragging', !animate);
      track.style.transform = `translate3d(${-index * 100}%, 0, 0)`;
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', String(active));
      });
    };

    previous?.addEventListener('click', () => {
      show(index - 1);
      scheduleAutoplay();
    });
    next?.addEventListener('click', () => {
      show(index + 1);
      scheduleAutoplay();
    });
    dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => {
      show(dotIndex);
      scheduleAutoplay();
    }));

    viewport.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      dragging = true;
      startX = event.clientX;
      deltaX = 0;
      stopAutoplay();
      viewport.setPointerCapture(event.pointerId);
      viewport.classList.add('is-dragging');
      track.classList.add('is-dragging');
    });

    viewport.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      deltaX = event.clientX - startX;
      const width = viewport.clientWidth || 1;
      track.style.transform = `translate3d(calc(${-index * 100}% + ${deltaX}px), 0, 0)`;
      if (Math.abs(deltaX) > width * .08) event.preventDefault();
    });

    const endDrag = (event) => {
      if (!dragging) return;
      dragging = false;
      viewport.classList.remove('is-dragging');
      const threshold = Math.min(90, viewport.clientWidth * .16);
      const target = Math.abs(deltaX) >= threshold ? index + (deltaX < 0 ? 1 : -1) : index;
      show(target);
      scheduleAutoplay();
      if (viewport.hasPointerCapture(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
    };

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    show(0, false);
    scheduleAutoplay();

    document.addEventListener('visibilitychange', scheduleAutoplay);
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.contains(carousel)) stopAutoplay();
    }, { once: true });
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-ph-media-carousel]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
